import styled from "@emotion/styled";
import { Breakpoints } from "@stepfinance/react";
import { Col, Row } from "antd";
import type { FC } from "react";
import React from "react";

import type { CollapseControlProps } from "../../../hooks/home/useCollapseControl";
import { NetWorth } from "./NetWorth";
import { YieldingPositions } from "./YieldingPositions";

export const PortfolioOverview: FC<CollapseControlProps> = (props) => {
  return (
    <Row align="top" justify="space-between">
      <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }}>
        <LeftPanelContainer>
          <NetWorth {...props} />
        </LeftPanelContainer>
      </Col>
      <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }}>
        <RightPanelContainer>
          <YieldingPositions {...props} />
        </RightPanelContainer>
      </Col>
    </Row>
  );
};

const LeftPanelContainer = styled.div`
  margin-right: 8px;

  @media (max-width: ${Breakpoints.M}px) {
    margin-right: 0;
    margin-bottom: 20px;
  }
`;

const RightPanelContainer = styled.div`
  margin-left: 8px;

  @media (max-width: ${Breakpoints.M}px) {
    margin-left: 0;
  }
`;
